<template>
  <div class="data-products">
    <section class="page-hero">
      <div class="container">
        <h1>数据产品</h1>
        <p>200+ 标准/可定制化接口，覆盖企业工商、司法、经营、税务、知识产权等全维度数据，传参即取、JSON 即回，一个工作日即可完成接入。</p>
        <div class="hero-actions">
          <!-- 锚点滚动统一走脚本，避免与路由跳转 / 滚动行为互相干扰 -->
          <a class="btn btn-ghost hero-btn-light" href="javascript:;" @click="scrollToTest">在线接口测试</a>
          <router-link class="btn btn-ghost hero-btn-outline" to="/consulting">查看我们的技术服务</router-link>
        </div>
      </div>
    </section>

    <!-- ============ 01 接口目录 ============ -->
    <section class="band" id="catalog">
      <div class="container">
        <div class="band-head">
          <span class="band-num">01</span>
          <h2>接口目录</h2>
          <span class="rule"></span>
        </div>
        <p class="band-lead">
          共 <b>{{ catTotal }}</b> 个数据分类、<b>{{ apiTotal }}</b> 个标准/可定制化接口，围绕「企业」这一核心实体，
          提供从工商注册到司法风险、从税务评级到股权穿透的全生命周期数据。点击分类卡片可直接在下方试调。
        </p>
        <div class="cat-grid" v-if="dims.length">
          <div class="cat-card cat-card-clickable" v-for="cat in dims" :key="cat.dimId" @click="selectCat(cat)">
            <b>{{ cat.dimName }}</b>
            <span class="count">{{ cat.intfNum || (cat.intfList || []).length }} 个接口</span>
            <span>{{ catSummary(cat) }}</span>
          </div>
        </div>
        <div v-else class="api-list-empty">接口目录加载中…</div>
      </div>
    </section>

    <!-- ============ 02 接口文档与详情 ============ -->
    <section class="band band-alt">
      <div class="container">
        <div class="band-head">
          <span class="band-num">02</span>
          <h2>接口文档与详情</h2>
          <span class="rule"></span>
        </div>
        <p class="band-lead">每个接口都提供接口 ID、请求方式、返回格式、请求参数表、返回字段说明、错误代码与 6 种语言示例代码——文档即接口，可直接对照联调。</p>
        <div class="grid grid-3">
          <div class="doc-card-sm" v-for="item in samples" :key="item.id">
            <div class="doc-card-top">
              <span class="doc-tag cat">{{ item.dimName }}</span>
            </div>
            <h3>{{ item.name }}</h3>
            <p>{{ item.descr }}</p>
            <div class="doc-card-foot">
              <span class="doc-card-meta">接口 ID：{{ item.id }}</span>
              <router-link class="doc-card-link" :to="`/apiDetail?dimId=${item.dimId}&id=${item.id}`">查看完整文档 →</router-link>
            </div>
          </div>
          <div class="doc-card-sm" v-if="!samples.length">
            <h3>接口文档加载中…</h3>
          </div>
        </div>
        <div class="doc-more">
          <span>以上为高频接口示例；完整的接口清单、请求参数与返回示例，均可在下方在线测试中逐个试调，或进入接口文档页逐个查看。</span>
          <a class="btn btn-ghost btn-sm" href="javascript:;" @click="scrollToTest">浏览全部接口 ↓</a>
        </div>
      </div>
    </section>

    <!-- ============ 03 在线接口测试 ============ -->
    <section class="band" id="api-test">
      <div class="container">
        <div class="band-head">
          <span class="band-num">03</span>
          <h2>在线接口测试</h2>
          <span class="rule"></span>
        </div>
        <p class="band-lead">选择接口、填入参数、立即测试——无需写代码即可预览返回结构，再决定接入哪一批接口。</p>
        <div class="api-grid">
          <api-list
            :dims="dims"
            :total="apiTotal"
            :active-id="currentApi ? currentApi.id : ''"
            :loading="leftLoading"
            @select="selectApi"
          ></api-list>
          <api-panel :api="currentApi" :logged="logged"></api-panel>
        </div>
      </div>
    </section>

    <!-- ============ 04 计费方式 ============ -->
    <section class="band band-alt">
      <div class="container">
        <div class="band-head">
          <span class="band-num">04</span>
          <h2>计费方式</h2>
          <span class="rule"></span>
        </div>
        <p class="band-lead">按调用场景灵活计费，登录 API 数据平台即可在线充值、查看用量与调用明细。</p>
        <div class="grid grid-3">
          <div class="card">
            <h3>包年调用</h3>
            <p>按年订阅接口，适合高频、稳定的系统性调用场景，成本最优。</p>
          </div>
          <div class="card">
            <h3>包天调用</h3>
            <p>按天购买接口使用权，适合短期项目、批量补数与临时核查。</p>
          </div>
          <div class="card">
            <h3>充值调用</h3>
            <p>按次计费、余额通用，适合低频灵活调用，随充随用。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA：两个出口分工明确——技术服务页 / 联系页 -->
    <section class="section" style="padding:0 0 96px;">
      <div class="container">
        <div class="cta cta-photo">
          <h2>标准接口之外，还需要定制数据？</h2>
          <p>从定制化数据获取到数据治理咨询，我们提供与 API 配套的咨询与实施服务。</p>
          <div class="cta-btns">
            <router-link class="btn" to="/consulting">了解技术服务</router-link>
            <router-link class="btn btn-outline-light" to="/contact">获取更多定制服务</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ApiList from '../../components/ApiList';
import ApiPanel from '../../components/ApiPanel';
import { portalApi } from '@/api';

/* 数据产品页（接口目录 + 接口文档示例 + 在线接口测试 + 计费方式）
   结构与视觉来自 website-handoff/data-products.html；
   数据与测试链路**完全沿用本项目原有接口**，未新增/修改任何接口：
     portal/api/dim/interface/detail  分类 + 接口清单（原 /apiTest、/apiDetail 左侧列表同源）
     portal/api/dim/interface/home    高频接口（原 /api 接口总览页同源）
     （测试面板内部另有 portal/api/interface/details、order/secret、order/invoke/left/num、https://{domainUrl}，
       见 src/components/ApiPanel.vue） */
export default {
  name: 'dataProducts',
  components: { ApiList, ApiPanel },
  data() {
    return {
      dims: [],
      catTotal: 0,
      apiTotal: 0,
      samples: [],
      leftLoading: true,
      currentApi: null,
      pendingId: ''
    };
  },
  computed: {
    logged() {
      const user = this.$cookies.getJSON('user');
      return !!(user && user.userId);
    }
  },
  mounted() {
    this.pendingId = this.$route.query.id || '';
    this.getCatalog();
    this.getSamples();
  },
  methods: {
    getCatalog() {
      this.leftLoading = true;
      portalApi.getInterfaceCatalog()
        .then((res) => {
          if (res.state === 200) {
            // 与原实现一致：状态码非 200 时提示错误
          } else {
            this.$message.error(res.message);
          }
          const data = res.data || {};
          this.dims = data.item || [];
          this.catTotal = this.dims.length;
          // data.total 是接口总数（与旧 /apiTest 列表头 (total) 同源）；intfNum 可能为 null，故做兜底求和
          this.apiTotal = data.total ||
            this.dims.reduce((sum, cat) => sum + (cat.intfNum || (cat.intfList || []).length), 0);
          this.leftLoading = false;
          this.applyInitialSelection();
        })
        .catch(err => {
          this.leftLoading = false;
          this.$message.error(err);
        });
    },
    getSamples() {
      portalApi.getInterfaceSamples({ dimIntfNum: 8 })
        .then((res) => {
          const list = [];
          (res.data || []).forEach(cat => {
            (cat.intfList || []).forEach(item => {
              list.push({
                id: item.id,
                name: item.name,
                descr: item.descr,
                dimId: cat.dimId,
                dimName: cat.dimName
              });
            });
          });
          this.samples = list.slice(0, 3);
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    /* 初始选中：优先 URL 指定的接口 → 该分类首个接口 → 全表首个接口 */
    applyInitialSelection() {
      const queryId = this.pendingId;
      const queryDimId = this.$route.query.dimId;
      for (let i = 0; i < this.dims.length; i++) {
        const cat = this.dims[i];
        const list = cat.intfList || [];
        if (queryId) {
          const hit = list.filter(it => String(it.id) === String(queryId))[0];
          if (hit) {
            this.selectApi({ api: hit, cat: cat });
            this.scrollToTest();
            return;
          }
        }
        if (queryDimId && String(cat.dimId) === String(queryDimId) && list.length) {
          this.selectApi({ api: list[0], cat: cat });
          this.scrollToTest();
          return;
        }
      }
      const firstCat = this.dims.filter(c => (c.intfList || []).length)[0];
      if (firstCat) this.selectApi({ api: firstCat.intfList[0], cat: firstCat });
    },
    selectApi(payload) {
      const api = payload.api || {};
      const cat = payload.cat || {};
      this.currentApi = Object.assign({}, api, { dimId: api.dimId || cat.dimId });
    },
    selectCat(cat) {
      const list = cat.intfList || [];
      if (list.length) {
        this.selectApi({ api: list[0], cat: cat });
      }
      this.scrollToTest();
    },
    scrollToTest() {
      this.$nextTick(() => {
        const el = document.getElementById('api-test');
        if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    catSummary(cat) {
      const names = (cat.intfList || []).map(it => it.name).slice(0, 4);
      return names.length ? names.join('、') : '接口清单加载中';
    }
  }
};
</script>

<style lang="less" scoped>
.data-products {
  .hero-actions { margin-top: 30px; display: flex; gap: 14px; flex-wrap: wrap; }
  .hero-btn-light { background: #fff; }
  /* 首屏副按钮「查看我们的技术服务」用全局 .hero-btn-outline（半透明白描边），与技术服务页同款 */
  .cat-card-clickable { cursor: pointer; }
}
</style>



// WEBPACK FOOTER //
// src/views/api/index.vue